import {ParameterBase} from '~/app/core/reports/models/ParameterBase';

export class ChainSelectField extends ParameterBase<string> {
  controlType = 'chainselectfield';
  showMasterLabel = true;
}
